/**
 * Copyright © 2026 Adnuntius AS.
 */
import * as _ from 'lodash';

import {Uuid} from '../../../util/uuid';
import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the NotificationPreferences HTTP resource (factory product). */
export class NotificationPreferencesResource {
}

export function createNotificationPreferencesResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const NotificationPreferences: any = createAdnHttpResource(
    createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler),
    'notificationpreferences',
    () => localUserProfile,
    'notificationPreferences'
  );

  NotificationPreferences.get = function(): any {
    const value: any = {$resolved: false, results: []};
    const userId = localUserProfile.get().userId;
    value.$promise = NotificationPreferences.query({user: userId, orderBy: 'userId'}).$promise.then((response: any) => {
      const responsePreference = response.results[0] || (_.has(response, 'id') ? response : null);
      let notificationPreference = responsePreference
        ? new NotificationPreferences(_.omit(responsePreference, ['$promise', '$resolved', 'results']))
        : null;
      if (!notificationPreference?.user) {
        notificationPreference = new NotificationPreferences({id: Uuid.generate(), user: {id: userId}});
      }
      _.assign(notificationPreference, value, {$resolved: true});
      return notificationPreference;
    }, (response: any) => {
      value.$resolved = true;
      return Promise.reject(response);
    });
    return value;
  };

  return NotificationPreferences;
}

export const notificationPreferencesResourceProvider = {
  provide: NotificationPreferencesResource,
  useFactory: createNotificationPreferencesResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};
